import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { default as Old2005BlogPage, doNothingAnchor } from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—August 2006" />
	<Old2005BlogPage>
		<h2>August 2006</h2>




		<h3 className="blogdate">
		Saturday, August 26, 2006
		</h3>






		<h4 className="blogitemtitle">
		Podcast: sounding loonie
		</h4>





			<div className="blogitembody">
			Some audio clips from Crooked Lake near Kelowna, B.C. Bryn, Cody and I saw some loons, very close to our boat, and I had my audio recorder with me...<br /><br /><ul><li><a href="/" onClick={doNothingAnchor}>(removed)</a></li><li><a href="http://www.ns.ec.gc.ca/wildlife/loons/">Read about loons</a></li></ul>
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060825/DSCN1777.jpg"
			alt="Crooked Lake, near Kelowna, BC"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060825/DSCN1754_2.jpg"
			alt="Crooked Lake, near Kelowna, BC"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060825/DSCN1781.jpg"
			alt="Crooked Lake, near Kelowna, BC"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060825/DSCN1741.jpg"
			alt="Crooked Lake, near Kelowna, BC"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />Laugh it up! Ha ha.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:54 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Podcast: The Romance of Kaslo
		</h4>





			<div className="blogitembody">
			Here's a song I wrote during the Kaslo Jazz Festival in Kaslo, B.C. It's called... <em>The Romance of Kaslo</em>! I had a great time in Kaslo and this song captures some of the magic I experienced.<br /><ul><li><a href="/" onClick={doNothingAnchor}>(removed)</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:52 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Wednesday, August 09, 2006
		</h3>






		<h4 className="blogitemtitle">
		Kaslo is magic, pure magic
		</h4>





			<div className="blogitembody">
			The Kootenays - wow! I MUST return. It was difficult to leave.<br /><br />My first time in the Kootenays (British Columbia, Canada), I awoke fully rested on Tina's sheltered deck, outside viewing Elephant Mountain (Nelson). It was a beautiful and serene change from sleeping next to the C-Train in Calgary. Tina is a beautiful soul whom I truly hope to meet again! Thanks to Tina for great conversation, great food and hosting, and introducing me to wonderful people like Bill and family, and John and Jamie.<br /><br />I hired a car and drove to Slocan to meet my new and wonderful friend, Melissa. We had a fresh, summery picnic lunch and then drove together to Kaslo through New Denver. What a stunningly natural scene to drive through! We arrived early for my show so we explored for a bit - we were both overwhelmed with smiles.<br /><br />The <em>Crooked Cafe</em> is permanently etched in my memory as a great venue filled with great people. I tried to end my show after two hours but the audience insisted that I keep playing - I couldn't say no! The staff at the cafe do an excellent job of collecting money throughout the show, as well as ensuring the sound is great! Thanks to Randy B., and especially to Chris for being a great host, in addition to being a true fan and promoter of music.<br /><br />Here's a photo (credit to Randy B.) of me playing at Crooked Cafe.<br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060809/crookedjesse.jpg"
			alt="Jesse Rivest at Crooked Cafe in Kaslo, BC, 2006"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={410}
			/>
			<br /><br />Friday night's Michael Franti (and Spearhead) concert, which commenced the Kaslo Jazz (&amp; etc) Festival, was one of the most unreal concert experiences I've had. I guess there were over four thousand people on the beach in Kaslo Bay, facing the floating stage on the water. The stars and moon lit the clear twilight sky, and the majestic, lake-side mountains were awesome silhouettes. Michael Franti's music and performance left everyone in unbreakable happinesss - wide, beaming smiles were everywhere! The man spreads so much infectious love and energy. I cheered louder and longer than I ever had, and many times throughout his performance I had to fill holes in the sand - I was dancing holes into the beach!<br /><br />Saturday was post-climactic because long-anticipated events had passed. However, Michael Franti's energy still burned inside me, and we drove to Silverton for a swim in Slocan Lake - a gorgeous lake! Driving to Kaslo after parting with Melissa, I reflected on my great fortune - exploring the Kootenays and it's beautiful people, while sharing music, energy, thoughts, and time with Melissa. The natural beauty and energy of Kaslo (and the Jazz Fest) was infectious - soon I was writing a song, and enjoying the outrageous live music parties at Crooked Cafe. Thanks to Grace for the company and the tasty curry!<br /><br />Back in Nelson, before departing for Kelowna, I ate a delicious wrap at the <em>Preserved Seed Bakery</em>, which is the front of a cooperative organic farming community (Twelve Tribes). I fell in love with a hat at the <em>Craft Connection</em>, a cooperative artist gallery/outlet - the hat is by Nelson's <em>J.Starr</em>. And I was curious to visit <em>Still Eagle</em>, an impressive hemp product outlet.<br /><br />Some photos to remember Michael Franti in Kaslo, <span style={{color: "rgb(255, 0, 0)"}}>all of which belong to <em>JP "Raven" Gregoire</em>, and/or the <em>Spirit of the Kootenays</em> website</span>. Click on each of them for the full picture!<br /><br />(sorry the pics have since been removed from the external website)<br /><br />Related Links:<br /><ul><li><a href="http://www.crookedcafe.com/">Crooked Cafe</a></li><li><a href="http://www.kaslojazzfest.com/">Kaslo Jazz Festival</a></li><li><a href="http://www.spiritofthekootenays.ca/gallery2/kaslojazz_2006">Spirit of the Kootenays</a></li><li><a href="http://www.spearheadvibrations.com/">Michael Franti</a></li><li><a href="http://www.jstarrwoolclothing.com/">J.Starr Wool Clothing</a></li><li><a href="http://www.stilleagle.com/">Still Eagle Hemp</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 8:02 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Calgary Folk Music Festival 2006
		</h4>





			<div className="blogitembody">
			My first experience with Calgary Folk Fest was rewarding and satisfying, overwhelming and inspiring, and fun and exciting! I truly would love to experience it again in 2007. Thanks to Brooke and Fitz for inviting me to get involved!<br /><br />I volunteered with a great crew of people to set up and tear down the stage tents. It was exciting to imagine live music in each tent that we raised, and it was sad to drop each tent after the festival. We all worked together for a common love of music!<br /><br />From Thursday to Sunday I all but slept at the festival! Non-stop music, great food, great people! Sometimes it was difficult to decide which stage to rush to as there were so many workshops and concerts to choose from. A few hightlights included Luke Doucet, Melissa McLelland, and Rachel Van Zanten.<br /><br />On Friday, Saturday, and Sunday nights, after the final mainstage performers, volunteers and performers partied at a nearby hotel. I "danced my ass off" to Doublestandart (with a special appearance from Ndidi Onukwulu), Aurelio Martinez, and Grupo Fantasma, and I met great people! I believe there were more than 1300 volunteers and over 65 performers.<br /><br />I have barely mentioned the incredible and inspiring talent that performed at this festival... check out the Calgary Folk Fest link below and see the pics and the artist line up... I loved every moment, and I was sad when it was all over.<br /><br />Related Links:<br /><ul><li><a href="http://www.calgaryfolkfest.com">Calgary Folk Fest</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:47 PM &nbsp;
			</div>





		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
